
import { Col, Form } from 'react-bootstrap';
import {useEffect, useState} from 'react';
import {storeComplaintLabel, getComplaintLabel,getNMBSLoginSelection} from '../storage/selectionStorage'
import PropTypes from 'prop-types';


function SpaceDropdown(props) {

	const localStorageTrustBuilder = JSON.parse(localStorage.getItem("trustBuilder")) ;
	const [selectedComplaint] = useState(localStorageTrustBuilder && getNMBSLoginSelection() && getComplaintLabel() ? getComplaintLabel()[0].complaintLabel : "")

	useEffect(()=>{
		let e = document.getElementById("complaintDropDown");
		let value = e.value;
		props.translatedComplaintCallback(value);
	},[props.langCode])

    const handleComplaint = (e) => {
        let selectedValue = e.target.value;
		if(selectedValue.length <= 0) {
			return props.callbackfunc(selectedValue);
		}
		const value = props.array.filter(function(item) {
			return item.complaintLabel == e.target.value
		  })
		storeComplaintLabel(value)
        props.callbackfunc(selectedValue,value[0].value.complaintId);
    }
    return(
        <Form.Group as={Col} className="form-group">	
			<Form.Label className="form-label" >{props.label} <span style={{ color: 'red' }}>*</span> :</Form.Label>
			<div className="select-wrapper">
			<Form.Select role="dropdown" id="complaintDropDown" className="complaint-select" defaultValue={selectedComplaint ? selectedComplaint : ""} onChange={(e) => {handleComplaint(e)}}>
				<option value=""></option>
				{ 
					props.array?.map((complaint) => { 										
					return <option  key={complaint.value.complaintId} value={complaint.complaintLabel} className="option">{complaint.complaintLabel}</option>
				})}
			</Form.Select>
			</div> 
			</Form.Group>
    )
}

SpaceDropdown.propTypes = {
  translatedComplaintCallback: PropTypes.func.isRequired,
  callbackfunc: PropTypes.func.isRequired,
	array: PropTypes.arrayOf(PropTypes.object),
	langCode: PropTypes.string,
	label: PropTypes.string,
};

export default SpaceDropdown;